import React from 'react';

const SvgTripEnd = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 96 96" ref={svgRef} {...props} fill="currentColor">
    <title>{title}</title>
    <path d="M34.5 1.4c-13.1 4.3-23 13.4-27.1 24.8-2.2 6.1-1.9 17.3.5 24.2 3.2 9.2 12.5 22.1 24.7 34.3C43.3 95.5 44 96 48 96s4.7-.5 15.4-11.3c12.2-12.2 21.5-25.1 24.7-34.4 2.9-8 2.4-20.8-.9-27.5-3.9-7.9-10.5-14.3-19-18.5C61 .7 60.1.5 49.6.3 42.5.1 37.1.5 34.5 1.4zm6 28.6c6.5 6.6 8.5 6.6 15 0 5.2-5.3 8.7-6.3 9.3-2.5.2 1.3-1.5 3.7-4.8 7-6.6 6.5-6.6 8.5 0 15 3.3 3.3 5 5.7 4.8 7-.6 3.8-4.1 2.8-9.3-2.5-3.4-3.4-5.7-5-7.5-5-1.8 0-4.1 1.6-7.5 5-3.3 3.3-5.7 5-7 4.8-3.8-.6-2.8-4.1 2.5-9.3 6.6-6.5 6.6-8.5 0-15-4.7-4.6-5.9-7.2-4.3-8.8 1.6-1.6 4.2-.4 8.8 4.3z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgTripEnd svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/TripEnd.js